import Loader from 'components/Common/Loader';
import NoData from 'components/Common/NoData';
import React, {FC, useMemo} from 'react';

import {TVProgramEvent} from 'utils/types';

import './styles.scss';

// BIQ: better solution while keeping <img> semantics? spritemap only?

import action24 from 'assets/img/tv/action24-2.png';
import alpha from 'assets/img/tv/alpha.png';
import ant1 from 'assets/img/tv/ant1.png';
import ant1_plus from 'assets/img/tv/ant1_plus.png'
import epsilontv from 'assets/img/tv/epsilontv.png';
import ert_1 from 'assets/img/tv/ert1.png';
import ert_2 from 'assets/img/tv/ert2sport.png';
import ert_3 from 'assets/img/tv/ert3.png';
import ert_hd from 'assets/img/tv/ert_hd.png';
import ert_play1 from 'assets/img/tv/ert_play1.png';
import ert_play2 from 'assets/img/tv/ert_play2.png';
import ert_play3 from 'assets/img/tv/ert_play3.png';
import ert_play4 from 'assets/img/tv/ert_play4.png';
import ert_sports1 from 'assets/img/tv/ert_sports1.png';
import ert_sports2 from 'assets/img/tv/ert_sports2.png';
import ert_sports3 from 'assets/img/tv/ert_sports3.png';
import ert_sports4 from 'assets/img/tv/ert_sports4.png';
import ert_sports5 from 'assets/img/tv/ert_sports5.png';
import ert_sports6 from 'assets/img/tv/ert_sports6.png';
import espn_america from 'assets/img/tv/espn_america.png';
import eurosport_1 from 'assets/img/tv/eurosport_1.png';
import eurosport_2 from 'assets/img/tv/eurosport_2.png';
import extra3 from 'assets/img/tv/extra3.png';
import fox_sports_hd from 'assets/img/tv/fox_sports_hd.png';
import fox from 'assets/img/tv/fox.png';
import kriti_tv from 'assets/img/tv/kriti_tv.png';
import makedonia_tv from 'assets/img/tv/makedonia_tv.png';
import mega from 'assets/img/tv/mega.png';
import novasport_1 from 'assets/img/tv/novasport_1.png';
import novasport_2 from 'assets/img/tv/novasport_2.png';
import novasport_3 from 'assets/img/tv/novasport_3.png';
import novasport_4 from 'assets/img/tv/novasport_4.png';
import novasport_5 from 'assets/img/tv/novasport_5.png';
import novasport_6 from 'assets/img/tv/novasport_6.png';
import novasports_start from 'assets/img/tv/novasports_start.png';
import novasports_premier_league from 'assets/img/tv/novasports_premier_league.png'
import novasports_prime from 'assets/img/tv/novasports_prime.png';
import novasports_news from 'assets/img/tv/novasports_news.png';
import open from 'assets/img/tv/open.png';
import magenta_sport_1 from 'assets/img/tv/magenta_sport_1.png';
import magenta_sport_2 from 'assets/img/tv/magenta_sport_2.png';
import magenta_sport_3 from 'assets/img/tv/magenta_sport_3.png';
import magenta_sport_4 from 'assets/img/tv/magenta_sport_4.png';
import magenta_sport_5 from 'assets/img/tv/magenta_sport_5.png';
import magenta_sport_6 from 'assets/img/tv/magenta_sport_6.png';
import magenta_sport_7 from 'assets/img/tv/magenta_sport_7.png';
import magenta_sport_8 from 'assets/img/tv/magenta_sport_8.png';
import magenta_sport_9 from 'assets/img/tv/magenta_sport_9.png';
import magenta_sport_4k from 'assets/img/tv/magenta_sport_4k.png'
import magenta_sport_1_league from 'assets/img/tv/magenta_sport_1_league.png';
import magenta_sport_2_league from 'assets/img/tv/magenta_sport_2_league.png';
import magenta_sport_3_league from 'assets/img/tv/magenta_sport_3_league.png';
import magenta_sport_4_league from 'assets/img/tv/magenta_sport_4_league.png';
import magenta_sport_highlights from 'assets/img/tv/magenta_sport_highlights.png';
import magenta_sport_start from 'assets/img/tv/magenta_sport_start.png';
import skai from 'assets/img/tv/skai-new.png';
import skai_hybrid from 'assets/img/tv/skai_hybrid.png';
import sport24_webtv from 'assets/img/tv/sport24_tv.png';
import novasports_extra1 from 'assets/img/tv/novasports_extra1.png';
import novasports_extra2 from 'assets/img/tv/novasports_extra2.png';
import novasports_extra3 from 'assets/img/tv/novasports_extra3.png';
import novasports_extra4 from 'assets/img/tv/novasports_extra4.png';
import mega_play_hybrid from 'assets/img/tv/mega-hybrid.png';
import ert_news from 'assets/img/tv/ert_news.png';
import ert_world from 'assets/img/tv/ertworld.png';
import mega_news from 'assets/img/tv/mega_news.png'
import superbetyt from 'assets/img/tv/superbet_21.png';
import spor_fm_tv from 'assets/img/tv/spor_fm_tv_logo_v2_1.png';
import spor_fm_tv1 from 'assets/img/tv/spor_fm_tv1_logo_v2_1.png';
import spor_fm_tv2 from 'assets/img/tv/spor_fm_tv2_logo_v2_1.png';
import spor_fm_tv3 from 'assets/img/tv/spor_fm_tv3_logo_v2_1.png';
import spor_fm_tv4 from 'assets/img/tv/spor_fm_tv4_logo_v2_1.png';
import spor_fm_tv5 from 'assets/img/tv/spor_fm_tv5_logo_v2_1.png';


const channels: { [k: string]: string } = {
    1: novasport_1,
    2: novasport_2,
    3: novasport_3,
    4: novasport_4,
    5: novasport_5,
    6: novasport_6,
    8: magenta_sport_1,
    9: magenta_sport_2,
    10: magenta_sport_3,
    11: ert_3,
    12: ert_1,
    13: ert_hd,
    14: ert_2,
    15: action24,
    16: mega,
    17: ant1,
    18: magenta_sport_4,
    19: magenta_sport_5,
    20: eurosport_1,
    21: eurosport_2,
    22: sport24_webtv,
    23: magenta_sport_6,
    24: skai,
    26: alpha,
    27: magenta_sport_7,
    28: magenta_sport_8,
    30: fox_sports_hd,
    31: kriti_tv,
    33: epsilontv,
    34: espn_america,
    35: sport24_webtv,
    37: action24,
    39: skai,
    43: fox,
    45: novasports_extra1,
    46: novasports_extra2,
    50: extra3,
    51: makedonia_tv,
    58: ert_3,
    60: magenta_sport_9,
    62: open,
    64: ert_world,
    67: magenta_sport_highlights,
    80: ert_sports1,
    81: ert_sports2,
    82: ert_sports3,
    83: ert_sports4,
    84: ert_sports5,
    85: novasports_extra3,
    86: ert_sports6,
    88: novasports_start,
    89: novasports_prime,
    90: novasports_news,
    92: ert_world,
    97: novasports_premier_league,
    99: ant1_plus,
    100: novasports_extra4,
    103: skai_hybrid,
    104: mega_play_hybrid,
    106: ert_news,
    107: mega_news,
    108: magenta_sport_start,
    109: magenta_sport_4k,
    110: superbetyt,
    111: magenta_sport_1_league,
    112: magenta_sport_2_league,
    113: magenta_sport_3_league,
    114: magenta_sport_4_league,
    115: spor_fm_tv,
    116: spor_fm_tv1,
    117: spor_fm_tv2,
    118: spor_fm_tv3,
    119: spor_fm_tv4,
    120: spor_fm_tv5,
};

interface Props {
    loading?: boolean;
    tvData?: TVProgramEvent[];
}

const WidgetTVProgram: FC<Props> = ({loading, tvData}: Props) => {
    const today = useMemo(
        () => new Date().toLocaleDateString('el-GR', {weekday: 'long', day: 'numeric', month: 'long'}),
        []
    );

    return (
        <section className="WidgetTVProgram">
            <h3 className="WidgetTVProgram__header">ΠΡΟΓΡΑΜΜΑ ΤΗΛΕΟΡΑΣΗΣ</h3>
            <h4 className="WidgetTVProgram__today">{today}</h4>
            {(!tvData || !tvData.length) && loading && <Loader/>}
            {!tvData || !tvData.length ? (
                <NoData/>
            ) : (
                tvData.map(({id, time, competition, name, channelId}) => (
                    <div className="WidgetTVProgram__show" key={id}>
                        <span className="WidgetTVProgram__time">{time}</span>
                        <div className="WidgetTVProgram__info">
                            <span className="WidgetTVProgram__competition">{competition}</span>
                            <span className="WidgetTVProgram__name">{name}</span>
                        </div>
                        {channelId in channels && (
                            <div className={`WidgetTVProgram__channel WidgetTVProgram__channel--${channelId}`}>
                                <img src={channels[channelId]} alt="channel"/>
                            </div>
                        )}
                    </div>
                ))
            )}
            {/* eslint-disable react/jsx-no-target-blank */}
            <a
                className="WidgetTVProgram__button"
                href="https://www.sport24.gr/tvprogram/"
                target="_blank"
            >
                ΑΝΑΛΥΤΙΚΟ ΠΡΟΓΡΑΜΜΑ
            </a>
        </section>
    );
};

export default React.memo(WidgetTVProgram);
